import axios from 'axios'

import type { components } from '../constants/schema'

/**
 * 카탈로그 조회
 * @param uriKey 카탈로그 uri key
 * @returns CatalogDto
 */
export const getCatalog = async (uriKey: string) => {
  return (await axios.get<components['schemas']['CatalogDto']>(`/catalog/${uriKey}`)).data
}
